import type { ModuleManifest } from "./types";

export const dataFlowManifest: ModuleManifest = {
  name: "data-flow",
  label: "Flusso Dati",
  labelPlural: "Flussi Dati",
  coreBOSModule: "evDataFlow",
  wsidPrefix: "79x",
  type: "standard",
  routes: {
    list: "/data-flow",
    show: "/data-flow/show/:id",
    create: "/data-flow/create",
    edit: "/data-flow/edit/:id",
  },
  navigation: {
    icon: "NodeIndexOutlined",
    order: 13,
    group: "Security",
  },
  routing: {
    keywords: ["dataflow", "flusso", "flussi", "data-flow"],
    searchFields: ["dataflowname"],
    defaultSort: { field: "dataflowname", order: "asc" },
  },
  context: { supported: false, entityKey: "data-flow" },
  fields: [
    { name: "dataflowname", label: "Nome Flusso", type: "string", required: true },
    { name: "source", label: "Sorgente", type: "string" },
    { name: "destination", label: "Destinazione", type: "string" },
    { name: "data_categories", label: "Categorie Dati", type: "text" },
    { name: "legal_basis", label: "Base Giuridica", type: "picklist" },
    { name: "rel_account", label: "Account", type: "reference" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    { module: "Accounts", field: "rel_account", label: "Account", icon: "BankOutlined", displayField: "accountname" },
  ],
  requiredFields: ["dataflowname"],
  viewStrategy: "generic",
};
